import Header from "@/components/header/Header";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import callCenter from "@/assets/images/call-center.svg";
import NeedHelpButton from "@/components/need-help-button/need-help-button";
import { Button } from "@/components/ui/button";
import ButtonContainer from "@/components/button-container";

export default function ContactCenter() {
  const { t } = useTranslation();
  const history = useHistory();

  const goToSiteCredentialsHome = () => {
    history.push(`/site-credentials`);
  };

  return (
    <div className="flex flex-col justify-self-center items-center gap-10 pb-2 w-full">
      <Header
        title={t("new_contact_center.header_title")}
        subtitle={t("new_contact_center.subtitle")}
      />
      <img src={callCenter} alt="" />
      <ButtonContainer>
        <NeedHelpButton />
        <Button
          onClick={() => goToSiteCredentialsHome()}
          aria-label={t("common.back_to_menu")}
          type="button"
          variant="secondary"
        >
          {t("common.back_to_menu")}
        </Button>
      </ButtonContainer>
    </div>
  );
}
